// frontend/src/components/BrandHeader/index.js

import BrandLogo from "../../assets/logo";
import "./BrandHeader.css";

/**
 * Displays the current theme's logo at the top of quiz screens.
 * Uses runtime theming (window.__EXPO_THEME__) via BrandLogo.
 *
 * @param {Object} props
 * @param {"hero"|"compact"} [props.size="hero"] - Size mode:
 *   - "hero": large logo for lobby/waiting screens (similar to home page)
 *   - "compact": small logo for active question screens
 * @param {"host"|"player"} [props.variant="player"] - Device variant (used within compact mode):
 *   - "host": slightly larger for big screens
 *   - "player": smaller for phone screens
 * @param {string} [props.className] - Additional CSS classes
 */
function BrandHeader({ size = "hero", variant = "player", className = "" }) {
    const sizeClass = size === "compact" ? "brand-header--compact" : "brand-header--hero";
    const variantClass = variant === "host" ? "brand-header--host" : "brand-header--player";
    const classes = ["brand-header", sizeClass, variantClass, className].filter(Boolean).join(" ");

    return (
        <div className={classes}>
            <BrandLogo className="brand-header__logo" alt="Brand logo" />
        </div>
    );
}

export default BrandHeader;
